export default __webpack_public_path__ + "static/media/Line-chart.0c42f009.jpg";